'use client';

import { useCallback } from 'react';
import { shallow } from 'zustand/shallow';
import { MultiSelectDropdown } from '@repo/ui/OffersFilter/MultiSelectDropdown';
import { useFilterEvents } from '@repo/ui/OffersFilter/useFilterEvents';
import { useOffersFilterStore } from '../store';
import { useBonusFilterOptions } from '../store/hooks';

export const BonusSelect = ({
  isStickyBar = false,
  scrollBackToMainBar,
  actionSection,
  pageIdentifier,
  isFiltersInHeader,
}: {
  isStickyBar?: boolean;
  scrollBackToMainBar?: () => void;
  actionSection: string;
  pageIdentifier: string;
  isFiltersInHeader?: boolean;
}) => {
  const options = useBonusFilterOptions();
  const { handleUpdateFilterFormState, handleApplyFilters, appliedFilters } = useOffersFilterStore(
    ({ handleUpdateFilterFormState, handleApplyFilters, appliedFilters }) => ({
      handleUpdateFilterFormState,
      handleApplyFilters,
      appliedFilters,
    }),
    shallow,
  );
  const { updateFiltersEvent } = useFilterEvents({
    actionSection,
    pageIdentifier,
    additionalAttributes: {},
  });

  const handleChange = useCallback(
    (selectedLabels: string[]) => {
      if (scrollBackToMainBar) scrollBackToMainBar();
      setTimeout(
        () => {
          handleUpdateFilterFormState({ selectedBonusOptions: selectedLabels });
          const newState = handleApplyFilters();
          if (!newState) return;
          updateFiltersEvent({
            additional_attributes: { bonus_options: selectedLabels },
          });
        },
        scrollBackToMainBar ? 100 : 0,
      );
    },
    [handleUpdateFilterFormState, handleApplyFilters, updateFiltersEvent, scrollBackToMainBar],
  );

  return (
    <MultiSelectDropdown
      isStickyBar={isStickyBar}
      label="Bonus"
      options={options}
      selectedOptions={appliedFilters?.selectedBonusOptions || []}
      onChange={handleChange}
      useStore={useOffersFilterStore}
      isFiltersInHeader={isFiltersInHeader}
    />
  );
};
